(ns lupapalvelu.ui.hooks
  (:require [reagent.hooks :as hooks]))

(defn use-observable
  "Subscribe to the value of a Knockout observable."
  [obs]
  (let [[v set-v] (hooks/use-state (.peek obs))]
    (hooks/use-effect (fn []
                        (let [s (.subscribe obs (fn [x] (set-v x)))]
                          (fn []
                            (.dispose s)))))
    v))

(defn use-computed
  "Run the given function as Knockout Pure Computed and subscribe to the value"
  [f]
  ;; Use the function as state initializer.
  ;; Having an initial value is important as subscribe doesn't get called before
  ;; the first change.
  (let [[v set-v] (hooks/use-state f)]
    (hooks/use-effect (fn []
                        (let [c (.pureComputed js/ko f)
                              s (.subscribe c (fn [x] (set-v x)))]
                          (fn []
                            (.dispose s)
                            (.dispose c)))))
    v))

